import { render } from "./quotationlist.vue?vue&type=template&id=f2889ac2"
import script from "./quotationlist.vue?vue&type=script&lang=js"
export * from "./quotationlist.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__